import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { PopoverOrigin } from "@material-ui/core/Popover";
import React from "react";

import { EllipsisVerticalIcon } from "../../assets/icons";

export interface SimpleMenuAction {
    label: string;
    tooltip?: string;
    action: () => void;
    icon?: JSX.Element;
    id?: string;
}

interface Props {
    menuIcon?: JSX.Element;
    actions: SimpleMenuAction[];
    id?: string;
    position?:
        | "top"
        | "right"
        | "right-top"
        | "right-bottom"
        | "bottom"
        | "left"
        | "left-top"
        | "left-bottom";
}

export const SimpleMenu = React.forwardRef((props: Props, ref: any) => {
    const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | undefined>(
        undefined
    );

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(undefined);
    };

    const {
        menuIcon = (
            <IconButton color="primary">
                <EllipsisVerticalIcon />
            </IconButton>
        ),
        actions,
        position = "bottom",
    } = props;

    let anchorOrigin: PopoverOrigin;
    let transformOrigin: PopoverOrigin;

    switch (position) {
        case "top":
            anchorOrigin = { horizontal: "center", vertical: "top" };
            transformOrigin = { horizontal: "center", vertical: "bottom" };
            break;
        case "right":
            anchorOrigin = { horizontal: "right", vertical: "center" };
            transformOrigin = { horizontal: "left", vertical: "center" };
            break;
        case "right-top":
            anchorOrigin = { horizontal: "right", vertical: "top" };
            transformOrigin = { horizontal: "left", vertical: "top" };
            break;
        case "right-bottom":
            anchorOrigin = { horizontal: "right", vertical: "bottom" };
            transformOrigin = { horizontal: "left", vertical: "bottom" };
            break;
        case "bottom":
            anchorOrigin = { horizontal: "center", vertical: "bottom" };
            transformOrigin = { horizontal: "center", vertical: "top" };
            break;
        case "left":
            anchorOrigin = { horizontal: "left", vertical: "center" };
            transformOrigin = { horizontal: "right", vertical: "center" };
            break;
        case "left-top":
            anchorOrigin = { horizontal: "left", vertical: "top" };
            transformOrigin = { horizontal: "right", vertical: "top" };
            break;
        case "left-bottom":
            anchorOrigin = { horizontal: "left", vertical: "bottom" };
            transformOrigin = { horizontal: "right", vertical: "bottom" };
            break;
        default:
            // bottom
            anchorOrigin = { horizontal: "center", vertical: "bottom" };
            transformOrigin = { horizontal: "center", vertical: "top" };
            break;
    }

    const menuId = (!!props.id ? `${props.id}-` : "") + "simple-menu";
    return (
        <div>
            {React.cloneElement(menuIcon, {
                "aria-owns": anchorEl ? menuId : undefined,
                "aria-haspopup": "true",
                onClick: handleClick,
            })}
            <Menu
                id={menuId}
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                open={!!anchorEl}
                onClose={handleClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                disableAutoFocusItem
            >
                {actions.map((action, i) => (
                        <MenuItem
                            id={`simple-menu-item-${i}`}
                            key={action.label}
                            selected={false}
                            onClick={() => {
                                action.action();
                                handleClose();
                            }}
                            data-cy={`simple-menu-select-${action.label}`}
                        >
                            {action.icon && action.icon}
                            {action.label}
                        </MenuItem>
                    ))}
            </Menu>
        </div>
    );
});
